import styled from "styled-components";

export const StyledRange = styled.div`
    width: 100%;
    margin: 15px 0;
    padding: 0 18%;
    display: flex;
    flex: wrap;
    justify-content: space-around;
    & > input {
        padding: 2px;
    }
`;

export const StyledInputBlock = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: fit-content;
    height: 35px;
`;

export const StyledLabel = styled.label`
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
`

export const StyledInput = styled.input`
    font-family: 'Roboto', sans-serif;
    color: #333;
    font-size: 20px;
    padding: 4px;
    text-align: center;
    border-radius: 0.2rem;
    background-color: rgb(255, 255, 255);
    border: 1px solid #777;
    width: 100px;
    height: 35px;
    display: block;
    transition: all 0.3s;
`;

export const StyledButton = styled.button`
    font-family: 'Roboto', sans-serif;
    color: #333;
    font-size: 18px;
    padding: 0px 10px;
    border-radius: 0.2rem;
    background-color: rgb(255, 255, 255);
    border: 1px solid #777;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
    &:hover {
        background-color: rgb(211,211,211);
    }
`;